import React, { useEffect, useState } from "react";
import axios from "axios";
import QRCode from "qrcode";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { BiArrowBack, BiPrinter } from "react-icons/bi";
import { Colors } from "../../../assets/Colors";

const API = process.env.REACT_APP_API_URL;
const authHeaders = () => {
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  return { Authorization: "Bearer " + user.Token };
};

// Cetak barcode (QR) per kamar. QR membuka halaman publik /makan/<token> di alamat situs ini.
export default function BarcodeKamarPage() {
  const navigate = useNavigate();
  const [rooms, setRooms] = useState([]);
  const [qr, setQr] = useState({});
  const [cari, setCari] = useState("");

  useEffect(() => {
    axios.get(API + "getRoomBarcodes", { headers: authHeaders() })
      .then(async (r) => {
        const data = r.data.data || [];
        setRooms(data);
        const hasil = {};
        for (const x of data) {
          hasil[x.RoomID] = await QRCode.toDataURL(`${window.location.origin}/makan/${x.Token}`, { width: 240, margin: 1 });
        }
        setQr(hasil);
      })
      .catch((e) => toast.error(e.response?.data?.message || "Gagal memuat kamar"));
  }, []);

  const tampil = rooms.filter((r) => r.NamaRoom.toLowerCase().includes(cari.toLowerCase()));

  return (
    <div className="md:ml-64 px-4 md:px-6 pb-20">
      <style>{`@media print { .no-print { display: none !important; } .md\\:ml-64 { margin-left: 0 !important; } }`}</style>
      <div className="no-print flex items-center justify-between py-4">
        <button onClick={() => navigate("/general-affair/prasmanan")} className="flex items-center gap-1.5 text-sm text-gray-600 hover:text-gray-900">
          <BiArrowBack className="text-lg" /> Kembali
        </button>
        <div className="flex items-center gap-2">
          <input value={cari} onChange={(e) => setCari(e.target.value)} placeholder="Cari kamar…"
            className="border rounded-lg px-3 py-1.5 text-sm outline-none focus:border-orange-400" />
          <button onClick={() => window.print()} className="flex items-center gap-1 px-3 py-1.5 rounded-lg text-white text-sm font-semibold"
            style={{ background: Colors.primary }}>
            <BiPrinter /> Cetak
          </button>
        </div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {tampil.map((r) => (
          <div key={r.RoomID} className="border rounded-lg p-3 text-center bg-white break-inside-avoid">
            <div className="font-bold text-lg">{r.NamaRoom}</div>
            {qr[r.RoomID] ? <img src={qr[r.RoomID]} alt={r.NamaRoom} className="mx-auto" width={180} height={180} /> : <div className="h-[180px]" />}
            <div className="text-[11px] text-gray-500 mt-1">Scan untuk kode makan Prasmanan</div>
          </div>
        ))}
      </div>
    </div>
  );
}
